import { getOrCreateTooltip } from 'components/Chart/Chart/getOrCreateTooltip'
import { formatByLocale } from 'utils/formatMoney'
import styles from 'components/Chart/Chart/Tooltip.module.scss'

export const externalTooltipHandler = (context) => {
  // Tooltip Element
  const { chart, tooltip } = context
  const tooltipEl = getOrCreateTooltip(chart)

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0
    return
  }

  // Set Text
  if (tooltip.body) {
    const titleLines = tooltip.title || []

    const bodyLines = tooltip.dataPoints

    const tableHead = document.createElement('thead')

    titleLines.forEach((title) => {
      const tr = document.createElement('tr')

      const th = document.createElement('th')
      th.className = styles['tooltip__heading']
      const text = document.createTextNode(title)
      th.colSpan = 2

      th.appendChild(text)
      tr.appendChild(th)
      tableHead.appendChild(tr)
    })

    const tableBody = document.createElement('tbody')

    bodyLines.forEach((body, i) => {
      const colors = tooltip.labelColors[i]

      const span = document.createElement('span')
      span.className = styles['tooltip__icon']
      span.style.backgroundColor = colors.backgroundColor

      const tr = document.createElement('tr')

      const th = document.createElement('th')
      const td = document.createElement('td')
      const number = body.raw || 0
      const labelSuffix = body.dataset.labelSuffix || ''
      const tdText = document.createTextNode(
        formatByLocale(number, null, {
          maximumFractionDigits: 2,
        }) +
          ' ' +
          labelSuffix,
      )
      const thText = document.createTextNode(body.dataset.label)

      th.appendChild(span)
      th.appendChild(thText)
      td.appendChild(tdText)
      tr.appendChild(th)
      tr.appendChild(td)

      tableBody.appendChild(tr)
    })

    const tableRoot = tooltipEl.querySelector('table')

    // Remove old children
    while (tableRoot.firstChild) {
      tableRoot.firstChild.remove()
    }

    // Add new children
    tableRoot.appendChild(tableHead)
    tableRoot.appendChild(tableBody)
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas

  const { width } = chart.canvas.getBoundingClientRect()

  const isMobile = chart.canvas.getAttribute('data-is-mobile') === 'true'
  const tooltipPositionX = positionX + tooltip.caretX

  const tooltipX =
    tooltipPositionX + tooltip.width > width
      ? tooltipPositionX - (tooltipPositionX + tooltip.width - width)
      : tooltipPositionX - tooltip.width < 0
      ? tooltip.width
      : tooltipPositionX

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1
  tooltipEl.style.left = isMobile ? 0 : tooltipX + 'px'

  const tooltipPositionY = positionY + tooltip.caretY - tooltip.height - 40

  tooltipEl.style.top = isMobile
    ? 50 + 'px'
    : tooltipPositionY < 0
    ? 0
    : tooltipPositionY + 'px'
  tooltipEl.style.zIndex = isMobile ? 8 : 1
}
